import { SetupZendesk } from '@side/next-zendesk-sdk';
import { SetupPushNotifications } from './SetupPushNotifications';
import { useMessengerLauncherVisibility } from './useMessengerLauncherVisibility';

export function Initialization() {
  const { onReady } = useMessengerLauncherVisibility();

  return typeof window === 'undefined' ? null : (
    <>
      <SetupZendesk onReady={onReady} />
      <SetupPushNotifications />
    </>
  );
}
